var exports = {
  "kL": "xa15a2ab7--8f76e3--container",
  "Pf": "xa15a2ab7--8f76e3--label",
  "DD": "xa15a2ab7--8f76e3--title",
  "Fp": "xa15a2ab7--8f76e3--link-container",
  "nf": "xa15a2ab7--8f76e3--link",
  "p_": "xa15a2ab7--8f76e3--list",
};

module.exports = exports;
